/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Children_TitleInputs */

const en_privacy_children_title = /** @type {(inputs: Privacy_Children_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`11. Children`)
};

const de_privacy_children_title = /** @type {(inputs: Privacy_Children_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`11. Kinder und Jugendliche`)
};

const fr_privacy_children_title = /** @type {(inputs: Privacy_Children_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`11. Mineurs`)
};

const es_privacy_children_title = /** @type {(inputs: Privacy_Children_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`11. Menores`)
};

const it_privacy_children_title = /** @type {(inputs: Privacy_Children_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`11. Minori`)
};

const nl_privacy_children_title = /** @type {(inputs: Privacy_Children_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`11. Kinderen`)
};

const pl_privacy_children_title = /** @type {(inputs: Privacy_Children_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`11. Dzieci`)
};

const fi_privacy_children_title = /** @type {(inputs: Privacy_Children_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`11. Lapset`)
};

const da_privacy_children_title = /** @type {(inputs: Privacy_Children_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`11. Børn`)
};

const sv_privacy_children_title = /** @type {(inputs: Privacy_Children_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`11. Barn`)
};

/**
* | output |
* | --- |
* | "11. Children" |
*
* @param {Privacy_Children_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const privacy_children_title = /** @type {((inputs?: Privacy_Children_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Children_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_privacy_children_title(inputs)
	if (locale === "fr") return fr_privacy_children_title(inputs)
	if (locale === "es") return es_privacy_children_title(inputs)
	if (locale === "it") return it_privacy_children_title(inputs)
	if (locale === "nl") return nl_privacy_children_title(inputs)
	if (locale === "pl") return pl_privacy_children_title(inputs)
	if (locale === "fi") return fi_privacy_children_title(inputs)
	if (locale === "da") return da_privacy_children_title(inputs)
	if (locale === "sv") return sv_privacy_children_title(inputs)
	return en_privacy_children_title(inputs)
});